import {
  Card,
  CardBody,
  CardExpandToggler,
} from "./../../../components/card/card.jsx";
import Chart from "react-apexcharts";
import React, { useState, useEffect } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

function TopCards({ data }) {
  const navigate = useNavigate();
  const { config } = useAuth();
  const roleItem = config?.RoleCompanyMaster[0]?.feature_access;
  const showCost = roleItem?.find((item) => item === "Show Cost");
  const [pieData, setPieData] = useState(null);
  useEffect(() => {
    if (data) {
      let open = data.filter((s) => s.status === "Open")?.length || 0;
      let completed = data.filter((s) => s.status === "Completed")?.length || 0;
      let progress =
        data.filter((s) => s.status === "In Progress")?.length || 0;
      let hold = data.filter((s) => s.status === "On Hold")?.length || 0;
      setPieData([open, completed, progress, hold]);
    }
  }, [data]);
  function getChartOptions() {
    var themeColor = getComputedStyle(document.body)
      .getPropertyValue("--bs-theme")
      .trim();
    var themeColorRgb = getComputedStyle(document.body)
      .getPropertyValue("--bs-theme-rgb")
      .trim();

    return {
      pie: {
        colors: [
          "rgba(195, 111, 130, 1)",
          "#3dd2a5",
          "rgba(249,220,142, 1)",
          "rgb(121,121,121)",
        ],
        chart: {
          sparkline: { enabled: true },
          events: {
            click: function (event, chartContext, { dataPointIndex }) {
              const datas = ["Open", "Completed", "In Progress", "On Hold"];
              navigate("/alarm/list", {
                state: { status: datas[dataPointIndex] },
              });
            },
          },
        },
        stroke: { show: false },
        tooltip: {
          x: { show: true },
          y: {
            title: {
              formatter: function (seriesName) {
                return "";
              },
            },
          },
        },
      },
    };
  }
  const [chartOptions, setChartOptions] = useState(getChartOptions());
  return (
    <div className="row">
      <div className={"col-12"}>
        <Card className="mb-3">
          <CardBody style={{ minHeight: "184px" }}>
            <div className="d-flex fw-bold small mb-3">
              <span className="flex-grow-1">Total Work Order</span>
              <CardExpandToggler />
            </div>
            <div className="row align-items-center mb-2">
              <div className="col-5">
                <h3 className="mb-1">
                  {" "}
                  {pieData && pieData.reduce((a, b) => a + b, 0)}
                </h3>
                <div className="small text-inverse text-opacity-75 text-truncate">
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-open"></div>{" "}
                    <div>{pieData ? pieData[0] : 0} - Open </div>
                  </div>
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-success"></div>{" "}
                    <div>{pieData ? pieData[1] : 0} - Completed </div>
                  </div>
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-progress"></div>{" "}
                    <div>{pieData ? pieData[2] : 0} - In-Progress </div>
                  </div>

                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-invalid"></div>{" "}
                    <div>{pieData ? pieData[3] : 0} - On Hold </div>
                  </div>
                </div>
              </div>
              <div className="col-7">
                <div className="mt-n2" style={{ cursor: "pointer" }}>
                  {pieData && (
                    <Chart
                      type="pie"
                      height={"auto"}
                      width={"100%"}
                      options={chartOptions["pie"]}
                      series={pieData}
                    />
                  )}
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default TopCards;
